<template>
  <div class="home">
    <intro />

    <about-us />
  </div>
</template>

<script>
import Intro from '@/components/Intro'
import AboutUs from '@/components/AboutUs'

export default {
  components: { Intro, AboutUs },
  name: 'home'
}
</script>
<style lang="sass">
.home
  @apply mx-auto py-8
  max-width: 980px

.header
  @apply mb-8 border-b border-gray-300

.table
  @apply w-full text-left shadow rounded

  thead
    @apply text-sm text-gray-700 text-left
    th
      @apply py-2 px-4 uppercase

      &:first-child
        @apply rounded-tl
      &:last-child
        @apply rounded-tr
    tr
      @apply border-b-2 border-gray-400 rounded-t bg-gray-200
  tbody
    @apply bg-white
    td
      @apply py-2 px-4
    tr
      @apply border-b border-gray-300
      &:last-child
        @apply border-b-0
        >td
          &:first-child
            @apply rounded-bl
          &:last-child
            @apply rounded-br
</style>
